import { API, deleteRequest, getRequest, putRequest } from '@/api/api';
import { generateSearchParams } from '@/utils/generate-search-params';

import type {
  DeleteNotificationsDto,
  Notification,
  NotificationDto,
  NotificationPage,
  NotificationPageDto,
  NotificationsListFilters,
  ReadNotificationsDto,
} from './notifications.dto';
import { mapNotification } from './notifications.mappers';

export const getNotifications = async (
  limit: number,
  page: number,
  filters?: NotificationsListFilters,
): Promise<NotificationPage> => {
  const searchParams = generateSearchParams({ limit, page, ...filters });

  const { data } = await getRequest<NotificationPageDto>(
    API.NOTIFICATIONS,
    `notifications?${searchParams}`,
  );
  return {
    count: data.count,
    items: data.items.map(mapNotification),
    unread: data.unread,
  };
};

export const getNotification = async (id: string): Promise<Notification> => {
  const { data } = await getRequest<NotificationDto>(API.NOTIFICATIONS, `notifications/${id}`);
  return mapNotification(data);
};

export const readNotifications = (values: ReadNotificationsDto) =>
  putRequest(API.NOTIFICATIONS, `notifications/read`, values);

export const unreadNotifications = (values: ReadNotificationsDto) =>
  deleteRequest(API.NOTIFICATIONS, `notifications/read`, values);

export const readAllNotifications = () =>
  putRequest(API.NOTIFICATIONS, `notifications/read/all`, undefined);

export const deleteNotifications = (values: DeleteNotificationsDto) =>
  deleteRequest(API.NOTIFICATIONS, `notifications`, values);
